module.exports = __webpack_public_path__ + "static/media/surfing_white_24dp.72d2ce30.svg";